import "../src/scss/oes_theme.scss";

import { createApp } from "vue";

// Store
import { createPinia } from "pinia";

// Axios
import axios from "axios";
import VueAxios from "vue-axios";

import App from "./App.vue";

//Vue Router
import router from "./router";

// Style
import "./assets/main.css";

//AuthService
import { AuthService } from "./services/authService";
import { AuthServiceSymbol } from "./services/injection";
import Vue3Toasity, { type ToastContainerOptions } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import { toast } from "vue3-toastify";
import errorInterceptor from "./services/errorInterceptor";
import { useConfigStore } from "./stores/config";

const app = createApp(App);

app.use(Vue3Toasity, {
  autoClose: 5000,
  position: toast.POSITION.TOP_RIGHT,
  clearOnUrlChange: false,
} as ToastContainerOptions);

app.use(createPinia());

app.use(VueAxios, axios);

const initializeApp = async () => {
  const configStore = useConfigStore();
  await configStore.initializeConfig();
  app.use(router);

  app.config.globalProperties.$authService = new AuthService(configStore.$state);
  app.provide(AuthServiceSymbol, app.config.globalProperties.$authService);

  //Use Axios interceptor to handle errors & set api state
  axios.defaults.baseURL = configStore.ApiUrl;
  errorInterceptor();

  app.mount("#app");
};

initializeApp();

export { app };
